import {addGuideLayerEvent} from "./event";
import {inputPopupQueue} from "../popup-queue/index.js";

const {isAct, requireIIFE} = Mutil;

function addEventOnDesktopGuideLayer() {
    const $desktopGuideLayer = $("#desktopGuideLayer");
    /**
     * history.replaceState : request parameter 초기화 안시켜서 새로 고침 시, 계속 팝업뜨는 이슈로 parameter 제거용으로 사용
     * 최초 로그인시에만 동작 => 문제 생길 시 제거 (ex 서브도메인 or 프로젝트 초대)
     */
    history.replaceState({}, null, location.pathname);
    $desktopGuideLayer.focus();
    addGuideLayerEvent();
}

function loadDesktopGuideLayer(callback) {
    const $desktopGuideLayer = $("#desktopGuideLayer");
    const $desktopDownloadGuideArea = $("#desktopDownloadGuideArea");

    if($desktopGuideLayer.length > 0) {
        return addEventOnDesktopGuideLayer();
    }
    $desktopDownloadGuideArea.load("/flow-renewal/view/mainview/desktopDownloadGuide.jsp", function() {
        if(!isAct("main")) $("body").css("overflow-y", "hidden");
        $desktopDownloadGuideArea.find("#continueWeb").css("display", "none");
        focusLayerAndAddEvent();
        (typeof callback === "function") && callback();
        $desktopDownloadGuideArea.css("display", "block");
    })

    function focusLayerAndAddEvent() {
        $desktopGuideLayer.focus();
        addGuideLayerEvent();
    }
}

function removeDesktopGuideLayer() {
    if(isAct("main")) {
        collectGoogleManager();
    } else {
        $("body").css("overflow-y", "auto");
    }
    $("#desktopGuideLayer").remove();
    $("#desktopDownloadGuideArea").css("display", "none");
}

function collectGoogleManager() {
    const $desktopDownloadGuideArea = $("#desktopDownloadGuideArea");
    const isVisibleContinueWeb = $desktopDownloadGuideArea.find("#continueWeb").is(":visible");
    if(!window.isFirstLogin || "N" !== OVER_GUIDE_PERIOD_YN || !isVisibleContinueWeb) return;
    const GoogleTagManager = requireIIFE("GoogleTagManager");

    if (Often.isFunc("POPUP_QUEUE")) {
        $("#userguiding").css("display", "none");
        inputPopupQueue("#userguiding", 98, () => {
            setTimeout(() => {
                $("#userguiding").css("display", "block");
                GoogleTagManager?.collect({"event": "NewUser"});
            }, 1000);
        });
    } else {
        setTimeout(() => {
            GoogleTagManager?.collect({"event": "NewUser"});
        }, 1500);
    }
}

export {
    loadDesktopGuideLayer,
    addEventOnDesktopGuideLayer,
    removeDesktopGuideLayer,
}
